import React, { Component } from "react";
import { GoogleLogout } from "react-google-login";
import BackendLoginService from "./backendLoginService";
import { Redirect } from "react-router-dom";

export default class Logout extends Component {
  clientId =
    "119044322202-46ojakubusukc4f80ovkehdali45q380.apps.googleusercontent.com";

  constructor(props) {
    super(props);
    this.state = {
      redirect: null,
    };
  }

  onSuccess = (res) => {
    console.log("Client logout succesful:", res);
    //alert("Should go back to: " + this.props.location.state.from);
    // this.setState({ email: res.profileObj.email, tokenId: res.tokenId });

    BackendLoginService.getInstance().logout();

    console.log("Server logout succesful");
    let redirect = "/login";

    this.setState({ redirect: redirect });
  };

  onFailure = (res) => {
    console.log("Logout failed: res:", res);
    alert(`Failed to do client logout. 😢`);
  };

  renderAccountInfo = () => {
    let isLoggedIn = false;
    try {
      isLoggedIn = BackendLoginService.getInstance().isLoggedIn();
    } catch (e) {
      console.log(e);
    }

    return isLoggedIn ? <p className="card-text">Вы залогинены</p> : null;
  };

  render() {
    if (this.state.redirect) {
      console.log("Redirecting to: " + this.state.redirect);
      return (
        <Redirect
          push
          to={{
            pathname: this.state.redirect,
            // state: { product },
          }}
        />
      );
    }

    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="card">
          <div className="card-body text-center">
            {this.renderAccountInfo()}
            <GoogleLogout
              clientId={this.clientId}
              buttonText="Logout"
              onLogoutSuccess={this.onSuccess}
              onFailure={this.onFailure}
            />
          </div>
        </div>
      </div>
    );
  }
}
